import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../common/Forms/SingleSelect';

const DigitalIdCardSelect = ({ handleChange, options, selectedValue, index }) => {

  const updateCard = (card) => {
    if (card !== null) {
      handleChange(card);
    }
  }

  return (
    <Fragment>
      <input name={(index !== null) && `school[digital_id_cards_attributes][${index}][template_id]`}
             defaultValue={selectedValue && selectedValue.value}
             hidden/>
      <SingleSelect
        handleChange={updateCard}
        options={options}
        selectedValue={selectedValue}
        showCheckbox={true}
        placeholderText='Select template'
      />
    </Fragment>
  );
};

DigitalIdCardSelect.propTypes = {
  options: PropTypes.array,
  selectedValue: PropTypes.object,
  index: PropTypes.number
};

DigitalIdCardSelect.defaultProps = {
  options: [{}],
  selectedValue: {},
  index: 0
};

export default DigitalIdCardSelect;
